"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFundsOriginCorporationTrads = void 0;
exports.EFundsOriginCorporationTrads = {
    apport_compte_courant: "Apport en compte courant d'associé",
    cession_actif_immobiliers: "Cession d'actifs immobiliers par la personne morale",
    cession_actif_mobiliers: "Cession d'actifs de valeurs mobilières par la personne morale",
    emprunt: "Emprunt",
    epargne: "Epargne / Trésorerie",
    other: "Autre",
};
